import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, Grid, Link, Typography } from '@material-ui/core'

import styles from './styles'

const PreviewPage = () => {
  const { watch } = useFormContext()

  const pageTitle = watch('pageTitle')
  const pageSubtitle = watch('pageSubtitle')
  const primaryColor = watch('primaryColor')
  const primaryTextColor = watch('primaryFontColor')
  const secondaryColor = watch('secondaryColor')
  const secondaryTextColor = watch('secondaryFontColor')

  const useStyles = styles({
    pageTitle,
    pageSubtitle,
    primaryColor,
    primaryTextColor,
    secondaryTextColor,
    secondaryColor,
  })

  const classes = useStyles()

  return (
    <Box className={classes.boxFather}>
      <Box display="flex" flexDirection="column">
        {/* Header */}
        <Box className={classes.boxPortal}>
          <Typography variant="h6" className={classes.typographyHeader}>
            Cabeçalho
          </Typography>
          <Box width="100%" px={4}>
            <Box className={classes.BoxPrivacyFriendlyOrganization}>
              <Typography
                variant="body2"
                className={classes.typographyPrivacyFriendlyOrganization}
                style={{
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                {pageTitle || 'Esta organização é amiga da privacidade'}
              </Typography>
              <Typography
                variant="body2"
                className={classes.typographyPrivacyFriendlyOrganization}
                style={{
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                {pageSubtitle || 'em relação a Lei Geral de Proteção de Dados'}
              </Typography>
            </Box>
            <Box className={classes.boxCompanyData} p={4}>
              <Grid container spacing={4}>
                <Grid item xs={5} sm={3} className={classes.avatarCompany} />
                <Grid
                  item
                  xs={7}
                  sm={9}
                  className={classes.gridCompanyDataResponsibleDpo}
                >
                  <Typography variant="body2" className={classes.companyData}>
                    Dados da empresa
                  </Typography>
                  <Typography variant="body2">
                    Encarregado de Proteção de Dados(DPO) responsável
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        {/* Body */}
        <Box className={classes.boxFatherButtonPreview}>
          <Grid container spacing={4}>
            {Array.from({ length: 2 }, (_, index) => (
              <Grid item xs={6} key={index}>
                <Box className={classes.boxButtonPreviewOne}>
                  <Box className={classes.boxButtonPreviewTwo}>
                    <Typography
                      variant="body1"
                      className={classes.typographyButtonPreview}
                    >
                      Botão
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        {/* Rodapé */}
        <Box className={classes.boxFooter}>
          <Typography variant="h6" className={classes.typographyFooter}>
            Rodapé
          </Typography>
        </Box>
      </Box>
      <Typography variant="body2" className={classes.typographyViewChannel}>
        Visualização de como ficará exibição do canal no&nbsp;
        <strong>
          <Link
            href="https://www.privacidade.com.br/"
            target="_blank"
            className={classes.linkPortal}
          >
            privacidade.com.br
          </Link>
        </strong>
      </Typography>
    </Box>
  )
}

export default PreviewPage
